import React from 'react';
import {Skeleton} from '@material-ui/lab';
import {makeStyles} from '@material-ui/core/styles';
import {BreadcrumbWrapper} from './Breadcrumb.style'

const useStyles = makeStyles((theme) => ({
	skeletonWrapper: {
		width: "100%",
		backgroundColor: '#E9ECEF',
		padding: '16px 20px',
		borderRadius: '8px',
		marginBottom: '20px',
		marginTop: '20px',
		display: 'flex',
		alignItems: 'center',
		gap: '8px',
		boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
	},
	skeletonItem: {
		borderRadius: '4px',
	},
	separator: {
		color: '#9cc54b',
		fontWeight: 600,
		fontSize: '16px',
	},
}));

/**
 * Breadcrumb skeleton loader
 * @param {number} items - Number of breadcrumb items to show (default: 3)
 * @param {boolean} animation - Animation type: 'wave', 'pulse', or false (default: 'wave')
 */
const BreadcrumbSkeleton = ({items = 3, animation = 'wave'}) => {
	const classes = useStyles();

	// Generate random widths for variety
	const getRandomWidth = (index) => {
		const widths = [60, 80, 100, 70, 90];
		return widths[index % widths.length];
	};

	return (
		<BreadcrumbWrapper>
			<div className={classes.skeletonWrapper}>
				{[...Array(items)].map((_, index) => (
					<React.Fragment key={index}>
						{/* Breadcrumb item */}
						<Skeleton
							variant="text"
							width={getRandomWidth(index)}
							height={20}
							animation={animation}
							className={classes.skeletonItem}
						/>

						{/* Separator (except for last item) */}
						{index < items - 1 && (
							<span className={classes.separator}>›</span>
						)}
					</React.Fragment>
				))}
			</div>
		</BreadcrumbWrapper>
	);
};

export default BreadcrumbSkeleton;